import {all, fork} from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import changePasswordSaga from "./auth/changepwd/saga"
import LayoutSaga from "./layout/saga"
import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga"
import ecommerceSaga from "./e-commerce/saga"
import invoiceSaga from "./invoices/saga"
import contactsSaga from "./contacts/saga"
import tenantSaga from "./tenant/saga"
import UserImpersonationSaga from "./users/impersonation/saga"
import tenantAdminSaga from "./users/tenant/saga";
import configSaga from "./config/saga";
import customerSaga from "./customer/saga";
import projectsSaga from "./project/saga";
import cartSaga from "./e-commerce/cart/saga"
import offerSaga from "./offer/saga"
import brandSettingsSaga from "./brandsettings/saga";
import auditSaga from "./audit/saga";
import tasksSaga from "./task/saga"
import userSaga from "./users/saga";
import languageSaga from "./language/saga"
import labelSaga from "./label/saga"
import projectTemplateSaga from "./project-template/saga";
import manufacturerSaga from "./manufacturer/saga";

export default function* rootSaga() {
    yield all([
        //public
        AccountSaga(),
        fork(AuthSaga),
        ProfileSaga(),
        ForgetSaga(),
        fork(LayoutSaga),
        fork(calendarSaga),
        fork(chatSaga),
        fork(ecommerceSaga),
        fork(invoiceSaga),
        fork(contactsSaga),
        fork(tenantSaga),
        fork(UserImpersonationSaga),
        fork(tenantAdminSaga),
        fork(configSaga),
        fork(customerSaga),
        fork(projectsSaga),
        fork(cartSaga),
        fork(changePasswordSaga),
        fork(offerSaga),
        fork(brandSettingsSaga),
        fork(auditSaga),
        fork(tasksSaga),
        fork(userSaga),
        fork(languageSaga),
        fork(labelSaga),
        fork(projectTemplateSaga),
        fork(manufacturerSaga)
    ])
}
